import { render, staticRenderFns } from "./MemberTable.vue?vue&type=template&id=0fc9227a&scoped=true&"
import script from "./MemberTable.vue?vue&type=script&lang=js&"
export * from "./MemberTable.vue?vue&type=script&lang=js&"
import style0 from "./MemberTable.vue?vue&type=style&index=0&id=0fc9227a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc9227a",
  null
  
)

export default component.exports